import axios from "./axios";
import { AxiosReturn } from "./types";
import * as Requests from "./requests";

export const getReviewsTotalNumber = (
  token,
  filters = {}
): AxiosReturn<{ total_number: number }> => {
  return axios.get(Requests.totalReviewsNumber, {
    headers: {
      token,
    },
    params: filters,
  });
};
